module.exports = __webpack_public_path__ + "static/media/icon_actions.7197fb0b.svg";